// import { Graph } from "../assets/img";
import BannerSection from "../components/BannerSection";
import Boxes from "../components/Boxes";
import GraphSection from "../components/GraphSection";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import StayInTheLoop from "../components/StayInTheLoop";
import TextSection from "../components/TextSection";

const AdminView = (props) => {
    return (
        <>
            <div className="h-full md:h-[calc(100vh-68px)] flex flex-col justify-center overflow-hidden">
                <Hero />
                <BannerSection />
            </div>
            <Boxes />
            <div id="waitlist">
                <StayInTheLoop />
            </div>
            <TextSection />
            <GraphSection />
            <HowItWorks />
        </>
    );
};

export default AdminView;
